import { EntryType, ResponseChoiceValue } from './common'
import { MatrixItem, MatrixRow, QuestionItem } from './questionnaire'

export interface ResponseChoice {
  surveyId: string
  panelSupplierCode: string
  respondentId?: string
  isPreview: boolean
  enteringDatetime: string
  submissionDatetime: string
  questionId?: string
  entryPosition: number
  renderedEntryPosition: number
  previousEntryPosition: number
  contextPosition: number
  renderedContextPosition: number
  matrix?: Matrix
  entryType: EntryType
  questionTypeCode: string
  responseChoices: ResponseOptionChoice[]
  timeZone: string
  utcOffset: string
  experimentalDesignVersion?: number
}

export interface Matrix {
  matrixTitleId: string
  rowPosition: number
  renderedRowPosition: number
}

export interface ResponseOptionChoice {
  responseOptionId?: string
  position?: number
  renderedPosition?: number
  value: ResponseChoiceValue | string
  responseDatetime: string
  setNumber?: number
}

export interface MatrixResponseItem {
  matrix: MatrixItem
  choices: MatrixResponseRow[]
}

export interface MatrixResponseRow {
  row?: MatrixRow
  choices: ResponseOptionChoice[]
}

export interface QuestionResponseItem {
  question: QuestionItem
  choices: ResponseOptionChoice[]
}

export type CategoricalChoice = 'not_selected' | 'selected'

export enum ResponseType {
  Categorical = 'categorical',
  MaxDiff = 'max_diff',
  FreeText = 'free_text',
  Ranked = 'ranked',
  Slider = 'slider',
  SliderDefault = 'slider_default',
  TextHighlighter = 'text_highlighter',
  Conjoint = 'conjoint'
}

interface CategoricalOptionChoice {
  response_option_id: string
  categorical_choice: CategoricalChoice
  text_entry: string | null
  rendered_response_option_position: number
}

export interface CategoricalResponseChoiceInput {
  matrix_title_id: string | null
  question_id: string
  rendered_entry_position: number
  row_position: number | null
  rendered_row_position: number | null
  response_type: ResponseType.Categorical
  response_choices: CategoricalOptionChoice[]
}

export const toCategoricalChoice = (
  value: ResponseChoiceValue
): CategoricalChoice => {
  switch (value) {
    case ResponseChoiceValue.Selected:
      return 'selected'
    case ResponseChoiceValue.NotSelected:
      return 'not_selected'
    default:
      return 'selected'
  }
}
